import { useContext } from "react";
import { Box, Card, Grid2, Stack, Typography } from "@mui/material";
import InsightsIcon from "@mui/icons-material/Insights";
import RevaText from "components/common/RevaText";
import UserContext from "context/UserContext";

const OrganizationDashboard = () => {
  const { selectedOrganization } = useContext(UserContext);

  if (!selectedOrganization) return null;
  console.log(selectedOrganization);
  return (
    <Stack spacing={2} m={2} sx={{ m: 2, margin: "auto" }}>
      <Box
        className="background background-filter"
        justifyContent="center"
        sx={{
          backgroundImage: `url('${selectedOrganization.full_cover_url}')  !important`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          display: "flex",
          width: "100% !important",
          alignItems: "center",
          backgroundPosition: "center",
          p: { xs: 4, md: 16 },
        }}
      >
        <span>
          <RevaText variant="h1" textAlign="center">
            {selectedOrganization.name}
          </RevaText>
        </span>
      </Box>

      <Grid2 container spacing={3} sx={{ mt: 4 }}>
        <Grid2 size={{ xs: 6, md: 4, lg: 3 }}>
          <Card sx={{ p: 3, textAlign: "center" }}>
            <InsightsIcon fontSize="large" />
            <Typography variant="h6" sx={{ mt: 1 }}>
              Torneos activos
            </Typography>
            <Typography variant="h4">{selectedOrganization.metrics?.active_tournaments ?? 0}</Typography>
          </Card>
        </Grid2>

        {/* <Grid2 size={{ xs: 6, md: 4 }}>
          <Card sx={{ p: 3, textAlign: "center" }}>
            <InsightsIcon fontSize="large" />
            <Typography variant="h6" sx={{ mt: 1 }}>
              Torneos finalizados
            </Typography>
            <Typography variant="h4">{selectedOrganization.metrics?.active_tournaments ?? 0}</Typography>
          </Card>
        </Grid2> */}

        <Grid2 size={{ xs: 6, md: 4, lg: 3 }}>
          <Card sx={{ p: 3, textAlign: "center" }}>
            <InsightsIcon fontSize="large" />
            <Typography variant="h6" sx={{ mt: 1 }}>
              Jugadores únicos
            </Typography>
            <Typography variant="h4">{selectedOrganization.metrics?.unique_players ?? 0}</Typography>
          </Card>
        </Grid2>

        <Grid2 size={{ xs: 6, md: 4, lg: 3 }}>
          <Card sx={{ p: 3, textAlign: "center" }}>
            <InsightsIcon fontSize="large" />
            <Typography variant="h6" sx={{ mt: 1 }}>
              Rankings activos
            </Typography>
            <Typography variant="h4">{selectedOrganization.metrics?.active_rankings ?? 0}</Typography>
          </Card>
        </Grid2>

        <Grid2 size={{ xs: 6, md: 4, lg: 3 }}>
          <Card sx={{ p: 3, textAlign: "center" }}>
            <InsightsIcon fontSize="large" />
            <Typography variant="h6" sx={{ mt: 1 }}>
              Miembros afiliados
            </Typography>
            <Typography variant="h4">{selectedOrganization.metrics?.active_tournaments ?? 0}</Typography>
          </Card>
        </Grid2>
      </Grid2>
    </Stack>
  );
};

export default OrganizationDashboard;
